import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import telgrosadmin from "../../public/images/telgorsAdminWhite.svg";
import { 
  FiHome, 
  FiUsers, 
  FiAward, 
  FiMessageCircle, 
  FiFileText, 
  FiCreditCard, 
  FiHelpCircle, 
  FiAward as FiAward2,
  FiUserCheck,
  FiVideo,
  FiBookOpen,
  FiBarChart2,
  FiSettings,
  FiBell,
  FiUserPlus,
  FiDollarSign,
  FiTrendingUp,
  FiGrid,
  FiList,
  FiTag,
  FiStar,
  FiHeart,
  FiMenu,
  FiX
} from "react-icons/fi";
import { 
  MdOutlineAdminPanelSettings, 
  MdOutlineNotificationsActive, 
  MdOutlineSettingsApplications,
  MdOutlineDashboard,
  MdOutlinePeople,
  MdOutlineVideoLibrary,
  MdOutlineChat,
  MdOutlineDescription,
  MdOutlinePayments,
  MdOutlineSupport,
  MdOutlineGrading,
  MdOutlineSchool,
  MdOutlinePerson,
  MdOutlineMoney,
  MdOutlineTrendingUp,
  MdOutlineCampaign,
  MdOutlineVerified,
  MdOutlineGift,
  MdOutlineHelp,
  MdOutlineNotifications,
  MdOutlineCategory,
  MdOutlineSettings
} from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { RxDashboard } from "react-icons/rx";
import { LuUsers } from "react-icons/lu";
import { RiUserStarLine } from "react-icons/ri";
import { TbMessage2Cog, TbTextScan2 } from "react-icons/tb";
import { TbCreditCardPay } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";
import { PiCertificateLight, PiHandTap, PiVideoCameraLight } from "react-icons/pi";
import { VscGroupByRefType } from "react-icons/vsc";
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { BiMoneyWithdraw } from "react-icons/bi";

function Sidebar({ SidebarJSON, navbarOpen, setNavbarOpen, closeSidebar }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const dropdownRef = useRef(null);
  const [adminData, setAdminData] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const navRef = useRef(null);

  const onClickMenu = (url) => {
    navigate(url);
    closeSidebar();
  };

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 1025) {
      setNavbarOpen(false);
    }
  }, [windowWidth, setNavbarOpen]);

  useEffect(() => {
    try {
      const storedAdminData = localStorage.getItem("adminData");
      if (storedAdminData && typeof storedAdminData === "string") {
        setAdminData(JSON.parse(storedAdminData));
      }
    } catch (error) {
      console.error("Error parsing admin data from localStorage", error);
    }
  }, []);

  // Sidebar items with consistent icons
  const sidebarData = [
    {
      path: "/app/dashboard",
      icon: <FiHome size={18} />,
      sidebarName: "Dashboard Analytics",
      access: "dashboard_analytics"
    },
    {
      path: "/app/users",
      icon: <FiUsers size={18} />,
      sidebarName: "User Management",
      access: "user_management" 
    },
    {
      path: "/app/content",
      icon: <FiFileText size={18} />,
      sidebarName: "Course Management",
      access: "course_management"
    },
    {
      path: "/app/session",
      icon: <FiVideo size={18} />,
      sidebarName: "Session Management",
      access: "sessiion_management" 
    },
    {
      path: "/app/community",
      icon: <FiMessageCircle size={18} />,
      sidebarName: "Community Management",
      access: "community_management"
    },
    {
      path: "/app/teachers-subscription",
      icon: <FiBookOpen size={18} />,
      sidebarName: "Teachers Subscription",
      access: "teachers_subscription"
    },
    {
      path: "/app/teachers-withdrawal",
      icon: <FiDollarSign size={18} />,
      sidebarName: "Teachers Withdrawal",
      access: "teachers_withdrawal"
    },
    {
      path: "/app/payments&transactions",
      icon: <FiCreditCard size={18} />,
      sidebarName: "Payments & Transactions",
      access: "payement_moderation"
    },
    {
      path: "/app/adsAndPromotation",
      icon: <FiTrendingUp size={18} />,
      sidebarName: "Ads Promotion Management",
      access: "Ads_management"
    },
    {
      path: "/app/certificate",
      icon: <FiAward size={18} />,
      sidebarName: "Certification Management",
      access: "certificate_management"
    },
    {
      path: "/app/referal/reward",
      icon: <FiStar size={18} />,
      sidebarName: "Referral & Rewards System",
      access: "reward_management"
    },
    {
      path: "/app/helpsupport",
      icon: <FiHelpCircle size={18} />,
      sidebarName: "Support Ticket System",
      access: "support_management"
    },
    {
      path: "/app/notifications",
      icon: <FiBell size={18} />,
      sidebarName: "Notifications",
      access: "notification_management"
    },
    {
      path: "/app/preferencepanagement",
      icon: <FiGrid size={18} />,
      sidebarName: "Preference Management",
      access: "preference_management"
    },
    {
      path: "/app/admin",
      icon: <FiUserCheck size={18} />,
      sidebarName: "Admin Management",
      access: "admin_management"
    },
    {
      path: "/app/appSetting",
      icon: <FiSettings size={18} />,
      sidebarName: "App Setting",
      access: "setting_management"
    },
    {
      path: "/app/questions",
      icon: <FiHelpCircle size={18} />,
      sidebarName: "Questions",
      access: "setting_management"
    },
  ];

  const filteredSidebarData = sidebarData.filter(item => 
    adminData?.isMain || adminData?.access?.includes(item.access)
  );

  return (
    <div className="relative flex flex-col h-screen bg-gradient-to-b from-[#1a2332] to-[#212B36] shadow-xl overflow-hidden">
      {/* Close Button - Mobile */}
      <div className="absolute right-3 top-3 z-50 lg:hidden">
        <button
          onClick={() => setNavbarOpen(!navbarOpen)}
          className="p-1.5 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-200 text-white"
          aria-label="Close sidebar"
        >
          <FiX size={20} />
        </button>
      </div>

      {/* Logo Section - Fixed */}
      <div className="flex-shrink-0 flex items-center justify-center p-5 border-b border-white/10">
        <img 
          src={telgrosadmin} 
          alt="Logo" 
          className="h-[39px] w-[185px] object-contain" 
        />
      </div>

      {/* Navigation - Scrollable */}
      <div 
        ref={navRef}
        className="flex-1 overflow-y-auto overflow-x-hidden py-2 scrollbar-thin scrollbar-thumb-white/10 scrollbar-track-transparent"
        style={{
          scrollBehavior: 'smooth',
          WebkitOverflowScrolling: 'touch',
          overscrollBehavior: 'contain'
        }}
      >
        <div className="px-3 space-y-0.5">
          {filteredSidebarData?.map((item, index) => {
            const isActive = location.pathname.includes(item.path);
            const isHovered = hoveredItem === index;

            return (
              <button
                key={index}
                onClick={() => onClickMenu(item.path)}
                onMouseEnter={() => setHoveredItem(index)}
                onMouseLeave={() => setHoveredItem(null)}
                className={`
                  w-full flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all duration-200 group relative
                  ${isActive
                    ? 'bg-gradient-to-r from-[#855DF6] to-[#715EFE] text-white shadow-lg shadow-[#715EFE]/25'
                    : isHovered
                      ? 'bg-white/10 text-white'
                      : 'text-[#919EAB] hover:bg-white/5 hover:text-white'
                  }
                `}
              >
                {/* Active Indicator */}
                {isActive && (
                  <span className="absolute left-0 w-1 h-6 bg-white rounded-r-full"></span>
                )}

                {/* Icon */}
                <span className={`
                  text-lg transition-all duration-200 flex-shrink-0
                  ${isActive ? 'text-white' : isHovered ? 'text-white' : 'text-[#919EAB]'}
                `}>
                  {item.icon}
                </span>

                {/* Label */}
                <span className={`
                  text-sm font-medium transition-all duration-200 truncate
                  ${isActive ? 'text-white' : isHovered ? 'text-white' : 'text-[#919EAB]'}
                `}>
                  {item.sidebarName}
                </span>

                {/* Active Badge */}
                {isActive && (
                  <span className="ml-auto w-1.5 h-1.5 bg-white rounded-full animate-pulse"></span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Footer - User Info - Fixed */}
      {adminData && (
        <div className="flex-shrink-0 p-4 border-t border-white/10 bg-white/5 backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#855DF6] to-[#715EFE] flex items-center justify-center text-white font-semibold text-xs flex-shrink-0">
              {adminData?.userName?.charAt(0)?.toUpperCase() || 'A'}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white truncate">
                {adminData?.userName || 'Admin'}
              </p>
              <p className="text-xs text-[#919EAB] truncate capitalize">
                {adminData?.role?.replaceAll("_", " ") || 'Super Admin'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Scrollbar styling */}
      <style jsx>{`
        .scrollbar-thin::-webkit-scrollbar {
          width: 4px;
        }
        .scrollbar-thin::-webkit-scrollbar-track {
          background: transparent;
        }
        .scrollbar-thin::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.15);
          border-radius: 10px;
        }
        .scrollbar-thin::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.25);
        }
        
        /* Firefox scrollbar */
        .scrollbar-thin {
          scrollbar-width: thin;
          scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
        }
        
        /* Hide scrollbar when not hovering */
        .scrollbar-thin:not(:hover)::-webkit-scrollbar-thumb {
          background: transparent;
        }
        .scrollbar-thin:hover::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.15);
        }
        
        /* Ensure smooth scrolling on mobile */
        .scrollbar-thin {
          -webkit-overflow-scrolling: touch;
          overscroll-behavior: contain;
        }
      `}</style>
    </div>
  );
}

export default Sidebar;